import { ILine } from '../../global';
import moment from 'moment';

export function addIsSellingAttrToLines(lines: ILine[]) {
  const now = moment.utc();
  return lines.map((line) => {
    const { salesPeriod } = line;
    if (!salesPeriod) return line;
    const { start, end } = salesPeriod;
    const startedSelling = now > moment.utc(start);
    const finishedSelling = now > moment.utc(end);
    line.isSelling = startedSelling && !finishedSelling;
    return line;
  });
}
